import { ConciergeGeneralSettingsParser } from "@redotech/redo-model/concierge-settings/general";
import * as z from "zod/v4";
import { object } from "zod/v4";
export const updateConciergeGeneralSettings = {
  name: "updateConciergeGeneralSettings" as const,
  input: object({ settings: ConciergeGeneralSettingsParser.partial() }),
  output: z.null(),
};
